import appReducers from '../reducer/app';
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import applicationDraftReducer from "../reducer/applicationDraft";
import inboxReducers from "../reducer/inbox";
import processingInboxReducer from "../reducer/processingInbox";
import cropMarkApplicationReducers from "../reducer/cropMarkApplication";
import processingMarkApplicationReducers from "../reducer/processingMarkApplication";
import cropMarkDeclareReducers from "../reducer/cropMarkDeclare";
import processingMarkDeclareReducers from "../reducer/processingMarkDeclare";
import notificationReducers from "../reducer/notification";
import processingApplyRecordReducer from "../reducer/processingApplyRecords";
import cropMarkApplyRecordReducer from "../reducer/cropMarkApplyRecords";
import cropCertificationDataDownloadReducer from "../reducer/cropCertificationDataDownload";
import utilReducers from "../reducer/util";
import settingReducers from "../reducer/setting";
import processingAgriculturalOperatorReducer from "../reducer/processingAgriculturalOperator";


const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...contentReducers,
    ...applicationDraftReducer,
    ...inboxReducers,
    ...processingInboxReducer,
    ...cropMarkApplicationReducers,
    ...processingMarkApplicationReducers,
    ...cropMarkDeclareReducers,
    ...processingMarkDeclareReducers,
    ...notificationReducers,
    ...processingApplyRecordReducer,
    ...cropMarkApplyRecordReducer,
    ...cropCertificationDataDownloadReducer,
    ...utilReducers,
    ...settingReducers,
    ...processingAgriculturalOperatorReducer
};

export default rootReducer;
